/* Ellervane footer: link groups become accordions below 750px. Scoped to <ellervane-footer>. */
if (!customElements.get('ellervane-footer')) {
  customElements.define(
    'ellervane-footer',
    class EllervaneFooter extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.toggles = Array.from(this.querySelectorAll('.evf-toggle'));
        this.onChange = () => this.setMode();
        this.onClick = (event) => {
          const toggle = event.target.closest('.evf-toggle');
          if (!toggle || !this.contains(toggle) || !this.mq.matches) return;
          this.setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        };
        this.addEventListener('click', this.onClick);
        this.mq.addEventListener('change', this.onChange);
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const toggle = event.target.querySelector('.evf-toggle');
          if (toggle && this.mq.matches) this.setOpen(toggle, true);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.setMode();
        this.classList.add('evf--ready');
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.mq.removeEventListener('change', this.onChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setMode() {
        const mobile = this.mq.matches;
        this.toggles.forEach((toggle) => {
          const panel = document.getElementById(toggle.getAttribute('aria-controls'));
          toggle.setAttribute('aria-expanded', mobile ? 'false' : 'true');
          toggle.tabIndex = mobile ? 0 : -1;
          if (panel) panel.classList.toggle('is-open', !mobile);
        });
      }

      setOpen(toggle, open) {
        if (open) {
          // one group open at a time
          this.toggles.forEach((other) => { if (other !== toggle) this.setOpen(other, false); });
        }
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.classList.toggle('is-open', open);
      }
    }
  );
}
